export { VehicleImage } from './vehicle-image'
